export enum POS {
  GET_POS_CATEGORIES_REQUEST = '@pos/GET_POS_CATEGORIES_REQUEST',
  GET_POS_CATEGORIES_SUCCESS = '@pos/GET_POS_CATEGORIES_SUCCESS',
  GET_POS_CATEGORIES_FAIL = '@pos/GET_POS_CATEGORIES_FAIL',

  GET_POS_EMPLOYEES_REQUEST = '@pos/GET_POS_EMPLOYEES_REQUEST',
  GET_POS_EMPLOYEES_SUCCESS = '@pos/GET_POS_EMPLOYEES_SUCCESS',
  GET_POS_EMPLOYEES_FAIL = '@pos/GET_POS_EMPLOYEES_FAIL',
}

export interface IGetPOSPayload {
  siteId: string;
}
